import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getPerformance } from '../../api/APIServices';
import LineGraph from '../../components/LineGraph';
import TitleLink from '../../components/TitleLink'
import { API_STATUS } from '../../constants';

function Performance({ data }) {
  const { t } = useTranslation('global');
  const dispatch = useDispatch();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  let param = { isImprove: true, score: 0, percentage: 0, gData: [] }
  const [mvc, setMVC] = useState({ captionText: 'From BaseLine', ...param });
  const [sts, setSTS] = useState({ captionText: 'From BaseLine', ...param })
  const [tug, setTUG] = useState({ captionText: 'From BaseLine', ...param })
  const [weight, setWeight] = useState({ captionText: 'From BaseLine', ...param })
  const [pain, setPain] = useState({ captionText: 'From BaseLine', ...param })

  const [sain, setSAIN] = useState({ captionText: 'From BaseLine', ...param });
  const [psfs, setPSFS] = useState({ captionText: 'From BaseLine', ...param })
  const [pseq2, setPSEQ2] = useState({ captionText: 'From BaseLine', ...param })
  const [mental, setMental] = useState({ captionText: 'From BaseLine', ...param })
  const [hoos, setHOOS] = useState({ captionText: 'From BaseLine', ...param })
  const { data: performance, status } = useSelector((state) => state.performance);

  const navigate = useNavigate();
  const sensordata = () => {
    const path = `/sensordata/${data.userId}`;
    navigate(path);
  }
  const questionnaire = () => {
    const path = `/questionnaire/${data.userId}`;
    navigate(path);
  }

  const setGData = (item) => {
    let gData = []
    if (item && item.values) {
      gData = item.values.map((val) => {
        return { x: dayjs(val.date).format('DD/MM/YYYY'), y: val.value }
      });
    }
    return gData
  }

  useEffect(() => {
    dispatch(getPerformance(data.userId));

  }, []);

    useEffect(() => {
      const handleResize = () => {
        setIsMobile(window.innerWidth <= 768);
      };
  
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);

  
  return (
    <>
      <TitleLink boxTitle={t('performance')} />
      {/* Line Graphs Section start */}
      {status === API_STATUS.PENDING && <>{t('loading')}</>}
      {status === API_STATUS.SUCCESS && <>
        <div className={!isMobile?'linegraph-container-full':"linegraph-container"}>
          <LineGraph
            title={performance.mvc?.name || t('modumMax')}
            isImprove={performance.mvc?.isImprove}
            score={performance.mvc?.value}
            percentage={performance.mvc?.change}
            gData={setGData(performance.mvc)}
            captionText={performance.mvc?.captionText}
            handleBoxClick={sensordata}
          />
          <LineGraph
            title={performance.sts?.name || 'STS'}
            isImprove={performance.sts?.isImprove}
            score={performance.sts?.value}
            percentage={performance.sts?.change}
            gData={setGData(performance.sts)}
            captionText={performance.sts?.captionText}
            handleBoxClick={sensordata}
          />
          <LineGraph
            title={performance.tug?.name || 'TUG'}
            isImprove={performance.tug?.isImprove}
            score={performance.tug?.value}
            percentage={performance.tug?.change}
            gData={setGData(performance.tug)}
            captionText={performance.tug?.captionText}
            handleBoxClick={sensordata}
          />
          <LineGraph
            title={performance.weight?.name || 'Weight'}
            isImprove={performance.weight?.isImprove}
            score={performance.weight?.value}
            percentage={performance.weight?.change}
            gData={setGData(performance.weight)}
            captionText={performance.weight?.captionText}
            handleBoxClick={questionnaire}
          />
          <LineGraph
            title={performance.pain?.name || t('pain_level')}
            isImprove={performance.pain?.isImprove}
            score={performance.pain?.value}
            percentage={performance.pain?.change}
            gData={setGData(performance.pain)}
            captionText={performance.pain?.captionText}
            handleBoxClick={questionnaire}
          />
        </div>
        <div className={!isMobile?'linegraph-container-full':"linegraph-container"}>
          <LineGraph
            title={performance.sain?.name || 'SANE'}
            isImprove={performance.sain?.isImprove}
            score={performance.sain?.value}
            percentage={performance.sain?.change}
            gData={setGData(performance.sain)}
            captionText={performance.sain?.captionText}
            handleBoxClick={questionnaire}
          />
          <LineGraph
            title={performance.psfs?.name || 'PSFS'}
            isImprove={performance.psfs?.isImprove}
            score={Number(performance.psfs?.value).toFixed(2)}
            percentage={performance.psfs?.change}
            gData={setGData(performance.psfs)}
            captionText={performance.psfs?.captionText}
            handleBoxClick={questionnaire}
          />
          <LineGraph
            title={performance.pseq2?.name || 'PSEQ2'}
            isImprove={performance.pseq2?.isImprove}
            score={Number(performance.pseq2?.value).toFixed(2)}
            percentage={performance.pseq2?.change}
            gData={setGData(performance.pseq2)}
            captionText={performance.pseq2?.captionText}
            handleBoxClick={questionnaire}
          />
          <LineGraph
            title={performance.mental?.name || 'Mental Strength'}
            isImprove={performance.mental?.isImprove}
            score={Number(performance.mental?.value).toFixed(2)}
            percentage={performance.mental?.change}
            gData={setGData(performance.mental)}
            captionText={performance.mental?.captionText}
            handleBoxClick={questionnaire}
          />
          <LineGraph
            title={performance.hoos?.name || 'Hoos'}
            isImprove={performance.hoos?.isImprove}
            score={performance.hoos?.value}
            percentage={performance.hoos?.change}
            gData={setGData(performance.hoos)}
            captionText={performance.hoos?.captionText}
            handleBoxClick={questionnaire}
          />
        </div>
      </>
      }
      {/* Line Graphs Section end */}
    </>
  )
}

export default Performance